module.exports = __webpack_public_path__ + "static/media/github.4d145252.svg";